import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceFunctionDetailVideoChat',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,
      processing: false,
    }
  },
  mounted () {
    this.init()
    console.log('@@@ values', this.values)
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // model
      deviceModel: state => state.serviceFunctionDetail.deviceModel,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,
      serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
      communityUuid: state => state.serviceFunctionDetail.communityId,
      values: state => state.serviceFunctionDetail.values,
      deliveryType: state => state.serviceFunctionDetail.deliveryType,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // list
    deviceList () {
      return this.deviceModel.map(item => {
        return {
          value: item.deviceTypeUuid,
          label: item.modelNumber
        }
      })
    },

    videoCallCameraEnabledList() {
      return Constants.Service.VideoCallCameraEnabled;
    },

    videoCallCameraForcedOffList() {
      return Constants.Service.VideoCallCameraForcedOff;
    },

    videoCallVolumeList() {
      return Constants.Service.VideoCallVolume;
    },

    videoCallAutoEndTimeList() {
      return Constants.Service.VideoCallAutoEndTime;
    },

    // input
    inpDeviceTypeUuids: {
      get () {
        return this.values.inpDeviceTypeUuids
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeviceTypeUuids',
          value: value
        })
      }
    },
    inpIsVideoChatCmsLogDownloadTabVisible: {
      get () {
        return this.values.inpIsVideoChatCmsLogDownloadTabVisible
      },
      set (value) {
        this.setInputValue({
          key: 'inpIsVideoChatCmsLogDownloadTabVisible',
          value: value
        })
      }
    },
    inpFavoritesVisibleDeviceTypeUuids: {
      get () {
        return this.values.inpFavoritesVisibleDeviceTypeUuids
      },
      set (value) {
        this.setInputValue({
          key: 'inpFavoritesVisibleDeviceTypeUuids',
          value: value
        })
      }
    },
    inpIsFavoritesVisibleOnSPApp: {
      get () {
        return this.values.inpIsFavoritesVisibleOnSPApp
      },
      set (value) {
        this.setInputValue({
          key: 'inpIsFavoritesVisibleOnSPApp',
          value: value
        })
      }
    },
    inpIsAddressBookButtonVisibleOnDevice: {
      get() {
        return this.values.inpIsAddressBookButtonVisibleOnDevice
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsAddressBookButtonVisibleOnDevice',
          value: value
        })
      }
    },
    inpIsNickNameSearchButtonVisibleOnDevice: {
      get() {
        return this.values.inpIsNickNameSearchButtonVisibleOnDevice
      },
      set(value) {
        this.setInputValue({
          key: 'inpIsNickNameSearchButtonVisibleOnDevice',
          value: value
        })
      }
    },
    inpIsVideoCallCameraEnabled: {
      get () {
        return this.values.inpIsVideoCallCameraEnabled
      },
      set (value) {
        this.setInputValue({
          key: 'inpIsVideoCallCameraEnabled',
          value: value
        });
      }
    },
    inpIsVideoCallCameraForcedOff: {
      get() {
        return this.values.inpIsVideoCallCameraForcedOff
      },
      set(val) {
        this.setInputValue({
          key: 'inpIsVideoCallCameraForcedOff',
          value: val
        });
      }
    },
    inpIsAutoAnswerCallCameraEnabled: {
      get () {
        return this.values.inpIsAutoAnswerCallCameraEnabled
      },
      set (value) {
        this.setInputValue({
          key: 'inpIsAutoAnswerCallCameraEnabled',
          value: value
        });
      }
    },

    inpAutoAnswerCallVolume: {
      get () {
        return this.values.inpAutoAnswerCallVolume
      },
      set (value) {
        this.setInputValue({
          key: 'inpAutoAnswerCallVolume',
          value: value
        });
      }
    },

    inpAutoAnswerCallAutoEndTimeRadio: {
      get() {
        return this.values.inpAutoAnswerCallAutoEndTimeRadio
      },
      set(value) {
        this.setInputValue({
          key: 'inpAutoAnswerCallAutoEndTimeRadio',
          value: value
        });
      }
    },

    inpAutoAnswerCallAutoEndTime: {
      get() {
        return this.values.inpAutoAnswerCallAutoEndTime
      },
      set(value) {
        this.setInputValue({
          key: 'inpAutoAnswerCallAutoEndTime',
          value: value
        });
      }
    },

    inpVideoCallVolume: {
      get () {
        return this.values.inpVideoCallVolume
      },
      set (value) {
        this.setInputValue({
          key: 'inpVideoCallVolume',
          value: value
        });
      }
    },
    inpVideoCallAutoEndTimeRadio: {
      get () {
        return this.values.inpVideoCallAutoEndTimeRadio
      },
      set (value) {
        this.setInputValue({
          key: 'inpVideoCallAutoEndTimeRadio',
          value: value
        });
      }
    },
    inpVideoCallAutoEndTime: {
      get () {
        return this.values.inpVideoCallAutoEndTime
      },
      set (value) {
        this.setInputValue({
          key: 'inpVideoCallAutoEndTime',
          value: value
        });
      }
    },

    // validate
    inpDeviceTypeUuidsIsValid () {
      return Validator.validArray(this.inpDeviceTypeUuids)
    },
    isVideoCallCameraEnabledIsValid () {
      return this.inpIsVideoCallCameraEnabled != null
    },
    isAutoAnswerCallCameraEnabledIsValid () {
      return this.inpIsAutoAnswerCallCameraEnabled != null
    },
    autoAnswerCallVolumeIsValid () {
      return this.inpAutoAnswerCallVolume != null
    },
    autoAnswerCallAutoEndTimeRadioIsValid() {
      if (this.inpAutoAnswerCallAutoEndTimeRadio === 0) {
        return true
      } else {
        return Validator.validateNumber(this.inpAutoAnswerCallAutoEndTime, {
          min: Constants.Service.VideoCallAutoEndTimeInterval.min,
          max: Constants.Service.VideoCallAutoEndTimeInterval.max
        })
      }
    },
    videoCallVolumeIsValid () {
      return this.inpVideoCallVolume != null
    },
    videoCallAutoEndTimeRadioIsValid () {
      if (this.inpVideoCallAutoEndTimeRadio === 0) {
        return true
      } else {
        return Validator.validateNumber(this.inpVideoCallAutoEndTime, {
          min: Constants.Service.VideoCallAutoEndTimeInterval.min,
          max: Constants.Service.VideoCallAutoEndTimeInterval.max
        })
      }
    },
    formIsValid() {
      return (
        this.isVideoCallCameraEnabledIsValid &&
        this.videoCallVolumeIsValid &&
        this.videoCallAutoEndTimeRadioIsValid &&
        this.isAutoAnswerCallCameraEnabledIsValid &&
        this.autoAnswerCallVolumeIsValid &&
        this.autoAnswerCallAutoEndTimeRadioIsValid
      );
      // return this.inpDeviceTypeUuidsIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadDeviceList: 'serviceFunctionDetail/loadDeviceList'
    }),
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
    }),

    init () {
      this.inpIsVideoCallCameraEnabled =
        this.inpIsVideoCallCameraEnabled ? 1
          : this.inpIsVideoCallCameraForcedOff ? 3
            : 2
      
      this.loading = true
      console.log('communityUuid : ', this.communityUuid)

      //
      let deviceParams = {
        filters: {
          communityUuid: [this.communityUuid]
        }
      }

      // データ読出し
      this.loadDeviceList({
        deviceParams: deviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          console.log('inpFavoritesVisibleDeviceTypeUuids', this.inpFavoritesVisibleDeviceTypeUuids);
          console.log('inpIsFavoritesVisibleOnSPApp', this.inpIsFavoritesVisibleOnSPApp);
          console.log(res);

          if (this.inpFavoritesVisibleDeviceTypeUuids === null &&
            res.length > 0) {
            this.inpFavoritesVisibleDeviceTypeUuids = res
              .map(item => item.deviceTypeUuid);
          }

          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceFunction',
        params: {
          serviceId: this.serviceUuid
        }
      })
    },

    postData () {
      this.processing = true

      // リクエストパラメータ
      let parameters = {
        serviceUuid: this.serviceUuid,
        serviceFunctionUuid: this.serviceFunctionUuid,
        request: {
          videoChatSetting: {
            deviceTypeUuids: this.inpDeviceTypeUuids,
            isVideoChatCmsLogDownloadTabVisible: this.inpIsVideoChatCmsLogDownloadTabVisible,
            favoritesVisibleDeviceTypeUuids: this.inpFavoritesVisibleDeviceTypeUuids,
            isFavoritesVisibleOnSPApp: this.inpIsFavoritesVisibleOnSPApp,
            isAddressBookButtonVisibleOnDevice:this.inpIsAddressBookButtonVisibleOnDevice,
            isNickNameSearchButtonVisibleOnDevice:this.inpIsNickNameSearchButtonVisibleOnDevice,
            isVideoCallCameraEnabled: this.inpIsVideoCallCameraEnabled === 1,
            isVideoCallCameraForcedOff: this.inpIsVideoCallCameraEnabled === 3,
            videoCallVolume: this.inpVideoCallVolume,
            isAutoAnswerCallCameraEnabled: this.inpIsAutoAnswerCallCameraEnabled === 1,
            isAutoAnswerCallCameraForcedOff: this.inpIsAutoAnswerCallCameraEnabled === 3,
            autoAnswerCallVolume: this.inpAutoAnswerCallVolume,
            autoAnswerCallAutoEndTime: this.inpAutoAnswerCallAutoEndTimeRadio === 1
              ? this.inpAutoAnswerCallAutoEndTime
              : -1,
            videoCallAutoEndTime:
              this.inpVideoCallAutoEndTimeRadio === 1
                ? this.inpVideoCallAutoEndTime
                : -1
          },
          
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.functionName + '情報の登録',
              body: this.functionName + '情報を登録しました。',
            })

            // 一覧へリダイレクト
            this.turnBack()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // confirm
        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.functionName + '情報を登録しますか？'
        })
      }
    },

    changeDeviceTypeUuids () {

    }
  }
}